import React, { useState, useEffect } from "react";
import axios from "axios";
import { Select} from "antd";
import { API_RETAILER } from "../config/config";
import htmlParser from "html-react-parser";
import Cookies from "js-cookie";

const { Option } = Select;
const RETAILER_DATA_URL = API_RETAILER + "/list";


const RetailerList = (props) => {

    const {mid} = props;
    const [data, setData] = useState([]);

    const fetchdata = async() => {
        try{

            const response = await axios.post(
                RETAILER_DATA_URL,
                { mid: mid },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            );
            setData(response.data.list);
        } catch (error) {
          return ( { data: false });
        }      

    };

    // useEffect(() => {
    //     if (data.length === 0) {
    //         fetchdata();
    //     }
    // }, [data]);

    useEffect(() => {
        fetchdata();
    }, [mid]);  // eslint-disable-line react-hooks/exhaustive-deps

    const getRetailer = () => {       
        
            return data.map((item) => (               
                    <Option key={item.rid} value={item.rid}>
                        {htmlParser(item.name) + ` (rid: ` + item.rid + `)`}
                    </Option>                    
            ))
        
    };
    
    return (
        
        <Select 
            showSearch
            mode="multiple"
            showArrow="true"
            maxTagCount="responsive"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
            {...props}
            >    {data
            ? getRetailer()
            : null}</Select>
    );
};

export default RetailerList;